import React from "react";
import { Helmet } from "react-helmet";
import { useState } from "react";
import ImageGalleryComponent from "../Common/Gallery";

const ChristmasPartyforChildren = () => {
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);
    const image = [
        'https://cwc-react.s3.ap-south-1.amazonaws.com/img/Events/photo-booth-at-TMH-Dec-2017-2.jpg',
        'https://cwc-react.s3.ap-south-1.amazonaws.com/img/Events/photo-booth-at-TMH-Dec-2017.jpg',
        'https://cwc-react.s3.ap-south-1.amazonaws.com/img/Events/photo-booth-at-TMH-Dec-2017-4.jpg',
        'https://cwc-react.s3.ap-south-1.amazonaws.com/img/Events/photo-booth-at-TMH-Dec-2017-5.jpg'
    ];
    return (
        <>
            <Helmet>
                <title>Christmas party at Tata Memorial Hospital - Cope with Cancer</title>

                <link rel="canonical" href="https://www.copewithcancer.org/events-page/christmas-party-at-tata-memorial" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="Christmas party at Tata Memorial Hospital - Cope with Cancer" />
                <meta property="og:url" content="https://www.copewithcancer.org/events-page/christmas-party-at-tata-memorial" />
                <meta property="og:site_name" content="Cope with Cancer" />
                <meta property="article:publisher" content="https://www.facebook.com/copewithcancer/" />
                <meta property="og:image" content="https://cwc-react.s3.ap-south-1.amazonaws.com/img/Events/photo-booth-at-TMH-Dec-2017-4.jpg" />
                {/* <meta property="og:image" content="https://cwc-react.s3.ap-south-1.amazonaws.com/img/Events/photo-booth-at-TMH-Dec-2017-2.jpg" />
                <meta property="og:image" content="https://cwc-react.s3.ap-south-1.amazonaws.com/img/Events/photo-booth-at-TMH-Dec-2017.jpg" />
                <meta property="og:image" content="https://cwc-react.s3.ap-south-1.amazonaws.com/img/Events/photo-booth-at-TMH-Dec-2017-5.jpg" /> */}
                <meta property="og:image:width" content="400" />
                <meta property="og:image:height" content="300" />
                <meta name="twitter:card" content="summary" />
                <meta name="twitter:title" content="Christmas party at Tata Memorial Hospital - Cope with Cancer" />
                <meta name="twitter:site" content="@copewithcancer" />
                <meta name="twitter:image" content="https://cwc-react.s3.ap-south-1.amazonaws.com/img/Events/photo-booth-at-TMH-Dec-2017-4.jpg" />
                <meta name="twitter:creator" content="@copewithcancer" />
                <meta property="DC.date.issued" content="2017-12-26T11:30:16+00:00" />
            </Helmet>
            <div className="topspace">
                <div className="text-center">
                    <div className="awarenessprogrambanner"></div>
                    {/* <img src="https://cwc-react.s3.ap-south-1.amazonaws.com/img/Events/awareness_program_banner.jpg" alt="Awareness Program" className="w-100" ></img> */}
                    {/* <h1 class="bannerHeading">Awareness Program</h1> */}
                </div>
                <div className="contentBox">
                    <div className="container">
                        <p className="Bold18 text-center">Photo Booth Organized at Christmas Party for Children at Tata Memorial Hospital.</p>
                        <p className="Regular14 titleWidth mb20">Small attempt to make sure that they took with them some pleasant memories of Tata as well. More than 200 children with their caregivers were given a photograph clicked with props.</p>

                        <div className="row text-center">

                            <div className="col-md-4 mb20">
                                <img src="https://cwc-react.s3.ap-south-1.amazonaws.com/img/Events/photo-booth-at-TMH-Dec-2017-2.jpg" alt="copewithcancer" className="cardImg pointer"
                                    data-toggle="modal"
                                    data-target="#exampleModal"
                                    onClick={() => setSelectedImageIndex(0)} />
                            </div>
                            <div className="col-md-4 mb20">
                                <img src="https://cwc-react.s3.ap-south-1.amazonaws.com/img/Events/photo-booth-at-TMH-Dec-2017.jpg" alt="copewithcancer" className="cardImg pointer"
                                    data-toggle="modal"
                                    data-target="#exampleModal"
                                    onClick={() => setSelectedImageIndex(1)} />
                            </div>
                            <div className="col-md-4 mb20">
                                <img src="https://cwc-react.s3.ap-south-1.amazonaws.com/img/Events/photo-booth-at-TMH-Dec-2017-4.jpg" alt="copewithcancer" className="cardImg pointer"
                                    data-toggle="modal"
                                    data-target="#exampleModal"
                                    onClick={() => setSelectedImageIndex(2)} />
                            </div>
                            <div className="col-md-4">
                                <img src="https://cwc-react.s3.ap-south-1.amazonaws.com/img/Events/photo-booth-at-TMH-Dec-2017-5.jpg" alt="copewithcancer" className="cardImg pointer"
                                    data-toggle="modal"
                                    data-target="#exampleModal"
                                    onClick={() => setSelectedImageIndex(3)} />
                            </div>
                            <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div class="modal-dialog modalDialog" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header modalHeader">
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        {console.log(selectedImageIndex)}
                                        <div class="modal-body modalHeight pt0">
                                            <ImageGalleryComponent
                                                images={image}
                                                showThumbnails={false} // Hide thumbnails in popup
                                                showPlayButton={false}
                                                currentImageIndex={selectedImageIndex}
                                            />
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ChristmasPartyforChildren;
